import { TranslateModule } from '@ngx-translate/core';
import {
  Component,
  ChangeDetectionStrategy,
  output,
  input,
  effect,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Observable } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'action-column',
  templateUrl: './action-column.component.html',
  styleUrls: ['./action-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslateModule],
})
export class ActionColumnComponent {
  // Angular 21 - Use input signals
  readonly columnData = input<Observable<any>>();
  readonly additionData = input<Observable<any>>();

  aData: any;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onAction = output<{ action: string; columnData: any }>(); // {type:actionName,columnData }

  keyName = '';
  value: any;

  constructor() {
    // Use effect to reactively update when inputs change
    effect(() => {
      const colData = this.columnData();
      const addData = this.additionData();

      if (colData && addData) {
        // Subscribe to observables to get the actual data
        colData.subscribe((data: any) => {
          this.aData = data;

          // Get the additionData to extract keyName
          addData.subscribe((additionalInfo: any) => {
            if (additionalInfo?.keyName) {
              this.keyName = additionalInfo.keyName;
              this.value = this.aData?.[this.keyName];
            }
          });
        });
      }
    });
  }

  executeAction(action: string) {
    this.onAction.emit({ action, columnData: this.aData });
  }
}
